import React, { useState, useEffect, useMemo } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  useLocation,
} from "react-router-dom";

import Skeleton from "./components/Skeleton";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./pages/home/Home";
import Competition from "./pages/competition/Competition";
import Fanzone from "./pages/fanzone/Fanzone";
import Livescore from "./pages/livescore/Livescore";
import News from "./pages/news/News";
import Video from "./pages/videos/Videos";
import Terms from "./pages/terms/Teams";

import liverpool from "./pages/terms/teamImage/liverpool.png";
import atletico from "./pages/terms/teamImage/atletico.png";
import bayern from "./pages/terms/teamImage/bayern.png";
import chelsea from "./pages/terms/teamImage/chelsea.png";
import FCB from "./pages/terms/teamImage/FCB.png";
import inter from "./pages/terms/teamImage/inter.png";

import Teamdetail from "./pages/terms/Teamcomponents/teamdetails/Teamdetail";
import Playerdetail from "./pages/terms/Teamcomponents/playerdetail/Playerdetail";
import Playernews from "./pages/terms/Teamcomponents/playernews/Playernews";
import Playerstatistics from "./pages/terms/Teamcomponents/Playerstatistics/Playerstatistics";

import Review from "./pages/news/NewsComponent/review/Review";
import Menue from "./components/mymenue/Menue";

import Player from "./pages/players/Player";
import Playnews from "./pages/players/Playnews";
import Playstatistics from "./pages/players/Playstatistics";

import Competitionnews from "./pages/competition/competitionComponents/competitionnews/Competitionnews";
import Competitionplayer from "./pages/competition/competitionComponents/competitionplayer/Competitionplayer";
import Matches from "./pages/competition/competitionComponents/matches/Matches";
import Competitiontable from "./pages/competition/competitionComponents/comptable/Competitiontable";
import CompDetail from "./pages/competition/competitionComponents/compdetail/Competitiondetail";

import Teammatch from "./pages/terms/Teamcomponents/teammatch/Teammatch";
import Teamnews from "./pages/terms/Teamcomponents/teamnews/Teamnews";
import Teamstanding from "./pages/terms/Teamcomponents/teamstandings/Teamstanding";
import Teamsquad from "./pages/terms/Teamcomponents/teamsquad/Teamsquad";
import Livehighlight from "./pages/livescore/livehighlight/Livehighlight";
import LivescoreDate from "./pages/livescore/LivescoreDate";
import LivescoreLineup from "./pages/livescore/LivescoreLineup";
import LivescoreSummary from "./pages/livescore/LivescoreSummary";
import LivescoreComment from "./pages/livescore/LivescoreComment";
import LivescoreCommentary from "./pages/livescore/LivescoreCommentary";
import SignUp from "./pages/signup/SignUp";
import LogIn from "./pages/login/LogIn";
import Videos from "./pages/videos/Videos";
import WatchVideo from "./pages/videos/watchvideo/WatchVideo";
import LatestNews from "./pages/news/NewsComponent/latest/LatesNews";
import Author from "./pages/author/Author";
import ViewAuthor from "./pages/author/ViewAuthor";
import Profile from "./pages/portecctedRoute/Profile";
import AddSection from "./components/AddSection/AddSection";
import Search from "./pages/search/Search";
import NotFound from "./pages/notfound/NotFound";
import About from "./pages/aboutus/About";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";
import Advertise from "./pages/adviertise/Advertise";
import ContactUs from "./pages/contactus/ContactUs";
import TheQuiz from "./pages/quizzes/TheQuiz";
import ThePolls from "./pages/polls/ThePoll";
import Shop from "./pages/shop/Shop";
import Career from "./pages/career/Career";
import MyAi from "./pages/ai/MyAi";
import SubSection from "./components/Subsection/SubSection";

function ScrollToTop() {
  const { pathname } = useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [pathname]);

  const [isMatchTabRoute, setIsMatchTabRoute] = useState(false);

  useEffect(() => {
    const isMatchTabRoute =
      pathname.includes("/stat") ||
      pathname.includes("/lineup") ||
      pathname.includes("/summary") ||
      pathname.startsWith("/teams/") ||
      pathname.includes("/commentary");

    if (!isMatchTabRoute) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

const createSlug = (name) => {
  return name
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9]/g, "");
};

const MyBaseUrl = "https://crm.fadasports.com/api";

function TeamWrapper({ Teams, children, loading, dark }) {
  const { teamname } = useParams();

  console.log("teamname =", teamname);
  console.log("Teams =", Teams);

  const id = teamname?.split("-").pop();

  console.log("id =", id);

  console.log(
    Teams.map((t) => ({
      api_id: t.api_id,
      id: t.id,
    })),
  );

  const team = Teams.find(
    (item) => String(item.api_id) === id || String(item.id) === id,
  );

  console.log("matched team =", team);

  if (loading) return <Skeleton dark={dark} />;

  if (!team) {
    return <h3>Team not found</h3>;
  }

  return children(team);
}

function PlayerWrapper({ dark }) {
  const { slug } = useParams();
  const id = slug?.split("-").pop();

  const [playerData, setPlayerData] = useState(null);
  const [playerLoading, setPlayerLoading] = useState(true);
  const [playerError, setPlayerError] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchPlayer = async () => {
      try {
        setPlayerLoading(true);

        const response = await fetch(`${MyBaseUrl}/players/${id}`);

        if (!response.ok) {
          throw new Error("Failed to fetch player details");
        }

        const result = await response.json();

        if (result.status === "success") {
          setPlayerData(result.data);
        } else {
          throw new Error(result.message);
        }
      } catch (err) {
        setPlayerError(err.message);
      } finally {
        setPlayerLoading(false);
      }
    };

    fetchPlayer();
  }, [id]);

  return (
    <Player
      dark={dark}
      playerData={playerData}
      loading={playerLoading}
      error={playerError}
    />
  );
}

function PlaynewsWrapper({ dark, setDark }) {
  const { slug } = useParams();
  const id = slug?.split("-").pop();

  const [playerData, setPlayerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchPlayer = async () => {
      try {
        setLoading(true);

        const response = await fetch(`${MyBaseUrl}/players/${id}`);

        if (!response.ok) throw new Error("Failed to fetch player");

        const result = await response.json();

        if (result.status === "success") {
          setPlayerData(result.data);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayer();
  }, [id]);

  return (
    <Playnews
      dark={dark}
      setDark={setDark}
      playerData={playerData}
      loading={loading}
      error={error}
    />
  );
}

function PlaystatisticsWrapper({ dark, setDark }) {
  const { slug } = useParams();
  const id = slug?.split("-").pop();

  const [playerData, setPlayerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchPlayer = async () => {
      try {
        setLoading(true);

        const response = await fetch(`${MyBaseUrl}/players/${id}`);

        if (!response.ok) throw new Error("Failed to fetch player");

        const result = await response.json();

        if (result.status === "success") {
          setPlayerData(result.data);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayer();
  }, [id]);

  return (
    <Playstatistics
      dark={dark}
      setDark={setDark}
      playerData={playerData}
      loading={loading}
      error={error}
    />
  );
}

function CompetitionPlayerWrapper({ dark, competition, onPlayerClick }) {
  const competitionId = competition?.league?.id;

  const [players, setPlayers] = useState([]);
  const [playersLoading, setPlayersLoading] = useState(true);
  const [playersError, setPlayersError] = useState(null);

  useEffect(() => {
    if (!competitionId) return;

    const fetchTopPlayers = async () => {
      try {
        setPlayersLoading(true);

        const response = await fetch(
          `${MyBaseUrl}/competitions/${competitionId}/top-players`,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch players");
        }

        const result = await response.json();

        if (result.status === "success") {
          setPlayers(result.data);
        } else {
          throw new Error(result.message);
        }
      } catch (err) {
        setPlayersError(err.message);
      } finally {
        setPlayersLoading(false);
      }
    };

    fetchTopPlayers();
  }, [competitionId]);

  return (
    <Competitionplayer
      dark={dark}
      players={players}
      playersLoading={playersLoading}
      playersError={playersError}
      onPlayerClick={onPlayerClick}
      competition={competition}
      country={competition?.country?.name}
      league={competition?.league}
    />
  );
}

function CompetitionWrapper({ competitions, loading, dark, children }) {
  const { name, id } = useParams();

  const createSlug = (name) => {
    return name
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  if (loading) {
    return <CompDetail loading={true} />;
  }
  return children({
    league: {
      id,
      name,
    },
  });
}

function App() {
  const [competitions, setCompetitions] = useState([]);
  const [competitionsLoading, setCompetitionsLoading] = useState(true);
  const [competitionsError, setCompetitionsError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedPlayerName, setSelectedPlayerName] = useState(null);

  const handlePlayerClick = (player) => {
    setSelectedPlayerName(player?.player?.name || player?.name);
  };

  const [Teams, setTeams] = useState([]);
  const [teamsLoading, setTeamsLoading] = useState(true);
  const [teamsError, setTeamsError] = useState(null);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        setTeamsLoading(true);

        const response = await fetch(`${MyBaseUrl}/teams`);

        if (!response.ok) throw new Error("Failed to fetch teams");

        const result = await response.json();

        if (result.status === "success") {
          setTeams(result.data.data);
        } else {
          throw new Error(result.message);
        }
      } catch (err) {
        setTeamsError(err.message);
      } finally {
        setTeamsLoading(false);
      }
    };

    fetchTeams();
  }, []);

  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const response = await fetch(`${MyBaseUrl}/competitions`);

        if (!response.ok) throw new Error("Failed to fetch competitions");

        const result = await response.json();

        if (result.status === "success") {
          setCompetitions(result.data);
        }
      } catch (err) {
        setCompetitionsError(err.message);
      } finally {
        setCompetitionsLoading(false);
      }
    };

    fetchCompetitions();
  }, []);

  const filteredCompetitions = useMemo(() => {
    return competitions.filter((item) =>
      item?.league?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [competitions, searchTerm]);

  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches;

  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("app-theme");
    const lastActive = localStorage.getItem("app-theme-last-active");

    const INACTIVE_LIMIT = 30 * 60 * 1000;

    if (savedTheme && lastActive) {
      const now = Date.now();

      if (now - Number(lastActive) < INACTIVE_LIMIT) {
        return savedTheme === "dark";
      }
    }

    localStorage.removeItem("app-theme");

    return getSystemTheme();
  };

  const [dark, setDark] = useState(getInitialTheme);
  const [darkTog, setDarkTog] = useState(false);

  const [manualOverride, setManualOverride] = useState(() => {
    return !!localStorage.getItem("app-theme");
  });

  const darktoggle = () => {
    setDark((prev) => {
      const newTheme = !prev;

      localStorage.setItem("app-theme", newTheme ? "dark" : "light");

      localStorage.setItem("app-theme-last-active", Date.now().toString());

      return newTheme;
    });

    setDarkTog((prev) => !prev);

    setManualOverride(true);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e) => {
      if (!manualOverride) {
        setDark(e.matches);
      }
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [manualOverride]);

  useEffect(() => {
    const updateActivity = () => {
      if (localStorage.getItem("app-theme")) {
        localStorage.setItem("app-theme-last-active", Date.now().toString());
      }
    };

    window.addEventListener("click", updateActivity);
    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keydown", updateActivity);
    window.addEventListener("scroll", updateActivity);

    return () => {
      window.removeEventListener("click", updateActivity);
      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keydown", updateActivity);
      window.removeEventListener("scroll", updateActivity);
    };
  }, []);

  const [openMenu, setOpenMenu] = useState(false);
  const checkMenu = () => setOpenMenu(true);
  const closeMenue = () => setOpenMenu(false);

  const [active, setActive] = useState(1);
  const [selected, setSelected] = useState("overview");

  const handleNavClick = (tab, number) => {
    setSelected(tab);
    setActive(number);
  };

  const Name = competitions?.[0]?.league?.name || "Unknown League";

  const [selectedTeam, setSelectedTeam] = useState(null);

  const handlePage = (team) => {
    setSelectedTeam(team);
  };

  const handleBack = () => {
    setSelectedTeam(null);
  };

  const goalkeepers = [
    {
      id: 1,
      number: 1,
      name: "Kelvin Williams",
      mp: 23,
      goal: 12,
      assist: 20,
      card: 2,
    },
    {
      id: 2,
      number: 1,
      name: "Kelvin Williams",
      mp: 23,
      goal: 12,
      assist: 20,
      card: 2,
    },
    {
      id: 3,
      number: 1,
      name: "Kelvin Williams",
      mp: 23,
      goal: 12,
      assist: 20,
      card: 2,
    },
    {
      id: 4,
      number: 1,
      name: "Kelvin Williams",
      mp: 23,
      goal: 12,
      assist: 20,
      card: 2,
    },
    {
      id: 5,
      number: 1,
      name: "Kelvin Williams",
      mp: 23,
      goal: 12,
      assist: 20,
      card: 2,
    },
    {
      id: 6,
      number: 1,
      name: "Kelvin Williams",
      mp: 23,
      goal: 12,
      assist: 20,
      card: 2,
    },
  ];

  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const restoreUserSession = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const savedUser = localStorage.getItem("authUser");

        // Immediately restore user from localStorage (optimistic restore)
        if (token && savedUser) {
          try {
            const parsedUser = JSON.parse(savedUser);
            setUser({ ...parsedUser, token });
          } catch (parseErr) {
            console.error("Error parsing saved user:", parseErr);
            localStorage.removeItem("authToken");
            localStorage.removeItem("authUser");
            setUser(null);
          }

          // Optionally validate with backend in the background
          // This won't clear the session if validation fails (to handle offline scenarios)
          try {
            const response = await fetch(`${MyBaseUrl}/auth/me`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });

            if (response.status === 401 || response.status === 403) {
              // Token is invalid/expired - clear session
              console.log("Token invalid/expired, clearing session");
              localStorage.removeItem("authToken");
              localStorage.removeItem("authUser");
              setUser(null);
            } else if (response.ok) {
              // Backend confirms user is valid - update with fresh data
              const userData = await response.json();
              const parsedUser = JSON.parse(savedUser);
              setUser({ ...parsedUser, ...userData?.data, token });
            }
            // For other errors (network, 500, etc), keep the restored session
          } catch (validationErr) {
            console.warn(
              "Could not validate with backend, keeping local session:",
              validationErr,
            );
            // Keep the user logged in locally - don't clear on network errors
          }
        } else {
          setUser(null);
        }
      } catch (err) {
        console.error("Error restoring user session:", err);
        setUser(null);
      } finally {
        setLoadingUser(false);
      }
    };

    restoreUserSession();
  }, []);

  const [searchValue, setSearchValue] = useState("");

  return (
    <BrowserRouter>
      <div
        style={{
          backgroundColor: dark ? "#111111e7" : "whitesmoke",
          minHeight: "100vh",
          width: "100%",
        }}>
        <ScrollToTop />

        <Header
          user={user}
          dark={dark}
          setDark={setDark}
          darktoggle={darktoggle}
          darkTog={darkTog}
          openMenu={openMenu}
          checkMenu={checkMenu}
          closeMenue={closeMenue}
          setOpenMenu={setOpenMenu}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />

        <Menue
          dark={dark}
          setDark={setDark}
          openMenu={openMenu}
          checkMenu={checkMenu}
        />

        <div className="app-layout">
          <main className="app-main">
            <Routes>
              <Route
                path="/"
                element={
                  <Home dark={dark} setDark={setDark} MyBaseUrl={MyBaseUrl} />
                }
              />

              {/* <Route path="/fan-zone" element={<Fanzone dark={dark} setDark={setDark} />} /> */}

              <Route
                path="/livescore"
                element={
                  <Livescore
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/matches/:date"
                element={<LivescoreDate dark={dark} MyBaseUrl={MyBaseUrl} />}
              />

              <Route
                path="/matches/:slug/:id/:tab?"
                element={<Livehighlight dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              {/* <Route path="/matches/:slug/:id/lineups" element={<LivescoreLineup dark/>} />
        <Route path="/matches/:slug/:id/summary" element={<LivescoreSummary dark/>} />
        <Route path="/matches/:slug/:id/comments" element={<LivescoreComment dark/>} />
        <Route path="/matches/:slug/:id/commentary" element={<LivescoreCommentary dark/>} /> */}

              {/* <Route path="/news" element={<LatestNews dark={dark} setDark={setDark} />} /> */}

              <Route
                path="/news/:slug"
                element={
                  <Review dark={dark} user={user} MyBaseUrl={MyBaseUrl} />
                }
              />
              <Route
                path="/latest-news/:slug"
                element={<Review dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/latest-news"
                element={<LatestNews dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/authors"
                element={<Author dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/authors/:name"
                element={<ViewAuthor dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/ai"
                element={<MyAi dark={dark} MyBaseUrl={MyBaseUrl} />}
              />

              <Route
                path="/about-us"
                element={<About dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/privacy-policy"
                element={<PrivacyPolicy dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/advertise"
                element={<Advertise dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/contact-us"
                element={<ContactUs dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/shop"
                element={<Shop dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/career"
                element={<Career dark={dark} MyBaseUrl={MyBaseUrl} />}
              />

              <Route
                path="/quizzes"
                element={<TheQuiz dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/polls"
                element={<ThePolls dark={dark} MyBaseUrl={MyBaseUrl} />}
              />

              <Route
                path="/videos"
                element={
                  <Videos dark={dark} setDark={setDark} MyBaseUrl={MyBaseUrl} />
                }
              />
              <Route
                path="/videos/:slug"
                element={
                  <WatchVideo
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/teams"
                element={
                  <Terms
                    Teams={Teams}
                    selectedTeam={selectedTeam}
                    handlePage={handlePage}
                    setSelectedTeam={setSelectedTeam}
                    dark={dark}
                    loading={teamsLoading}
                    error={teamsError}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/teams/:id/*"
                element={
                  <Teamdetail
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />
              {/* <Route path="news" element={<Teamnews />} />
                <Route path="standings" element={<Teamstanding />} />
                <Route path="matches" element={<Teammatch />} />
                <Route path="squad" element={<Teamsquad />} />
              </Route> */}

              {/* <Route
                path="/teams/:teamname/news"
                element={
                  <Teamnews
                    dark={dark}
                    onBack={handleBack}
                    goalkeepers={goalkeepers}
                    setDark={setDark}
                    Teams={Teams}
                    handlePage={handlePage}
                    setSelectedTeam={setSelectedTeam}
                    loading={teamsLoading}
                    error={teamsError}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/teams/:teamname/standings"
                element={
                  <Teamstanding
                    onBack={handleBack}
                    goalkeepers={goalkeepers}
                    dark={dark}
                    setDark={setDark}
                    Teams={Teams}
                    handlePage={handlePage}
                    setSelectedTeam={setSelectedTeam}
                    loading={teamsLoading}
                    error={teamsError}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/teams/:teamname/matches"
                element={
                  <Teammatch
                    onBack={handleBack}
                    goalkeepers={goalkeepers}
                    dark={dark}
                    setDark={setDark}
                    handlePage={handlePage}
                    loading={teamsLoading}
                    error={teamsError}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/teams/:teamname/squad"
                element={
                  <Teamsquad
                    goalkeepers={goalkeepers}
                    onBack={handleBack}
                    dark={dark}
                    setDark={setDark}
                    Teams={Teams}
                    handlePage={handlePage}
                    setSelectedTeam={setSelectedTeam}
                    loading={teamsLoading}
                    error={teamsError}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              /> */}

              <Route
                path="/teams/players"
                element={
                  <Playerdetail
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />
              <Route
                path="/teams/player/news"
                element={
                  <Playernews
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />
              <Route
                path="/teams/player/statistics"
                element={
                  <Playerstatistics
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/players/:slug"
                element={<PlayerWrapper dark={dark} MyBaseUrl={MyBaseUrl} />}
              />
              <Route
                path="/players/:slug/news"
                element={
                  <PlaynewsWrapper
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />
              <Route
                path="/players/:slug/statistics"
                element={
                  <PlaystatisticsWrapper
                    dark={dark}
                    setDark={setDark}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/competition"
                element={<Competition dark={dark} MyBaseUrl={MyBaseUrl} />}
              />

              <Route
                path="/competition/:name/:id/*"
                element={
                  <CompetitionWrapper
                    competitions={competitions}
                    loading={competitionsLoading}
                    dark={dark}>
                    {(competition) => (
                      <CompDetail
                        dark={dark}
                        competition={competition}
                        country={competition?.country?.name}
                        currentSeason={competition?.seasons?.year}
                        MyBaseUrl={MyBaseUrl}
                      />
                    )}
                  </CompetitionWrapper>
                }
              />

              {/* <Route
                path="/competition/:name/:id/matches"
                element={
                  <CompetitionWrapper
                    loading={competitionsLoading}
                    competitions={competitions}
                    dark={dark}>
                    {(competition) => (
                      <Matches
                        competition={competition}
                        dark={dark}
                        competitionId={competition?.league?.id}
                        country={competition.country.name}
                        currentSeason={competition.seasons.year}
                        MyBaseUrl={MyBaseUrl}
                      />
                    )}
                  </CompetitionWrapper>
                }
              />

              <Route
                path="/competition/:name/:id/standings"
                element={
                  <CompetitionWrapper
                    loading={competitionsLoading}
                    competitions={competitions}
                    dark={dark}>
                    {(competition) => (
                      <Competitiontable
                        competition={competition}
                        dark={dark}
                        competitionId={competition?.league?.id}
                        country={competition.country.name}
                        currentSeason={competition.seasons.year}
                        MyBaseUrl={MyBaseUrl}
                      />
                    )}
                  </CompetitionWrapper>
                }
              />

              <Route
                path="/competition/:name/:id/news"
                element={
                  <CompetitionWrapper
                    loading={competitionsLoading}
                    competitions={competitions}
                    dark={dark}>
                    {(competition) => (
                      <Competitionnews
                        competition={competition}
                        competitions={filteredCompetitions}
                        dark={dark}
                        competitionId={competition?.league?.id}
                        country={competition.country.name}
                        currentSeason={competition.seasons.year}
                        MyBaseUrl={MyBaseUrl}
                      />
                    )}
                  </CompetitionWrapper>
                }
              />

              <Route
                path="/competition/:name/:id/players"
                element={
                  <CompetitionWrapper
                    loading={competitionsLoading}
                    competitions={competitions}
                    dark={dark}>
                    {(competition) => (
                      <CompetitionPlayerWrapper
                        dark={dark}
                        competition={competition}
                        onPlayerClick={handlePlayerClick}
                        MyBaseUrl={MyBaseUrl}
                      />
                    )}
                  </CompetitionWrapper>
                }
              /> */}

              <Route
                path="/signup"
                element={
                  <SignUp
                    dark={dark}
                    user={user}
                    setUser={setUser}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/login"
                element={
                  <LogIn
                    dark={dark}
                    user={user}
                    setUser={setUser}
                    MyBaseUrl={MyBaseUrl}
                  />
                }
              />

              <Route
                path="/profile"
                element={
                  user ? (
                    <Profile user={user} dark={dark} setUser={setUser} />
                  ) : (
                    <LogIn
                      dark={dark}
                      user={user}
                      setUser={setUser}
                      MyBaseUrl={MyBaseUrl}
                    />
                  )
                }
              />

              <Route
                path="/search"
                element={
                  <Search
                    dark={dark}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    MyBaseUrl={MyBaseUrl}
                    Teams={Teams}
                  />
                }
              />

              <Route path="*" element={<NotFound dark={dark} />} />
            </Routes>
          </main>

          <SubSection dark={dark} MyBaseUrl={MyBaseUrl} />
          {/* <AddSection dark={dark} MyBaseUrl={MyBaseUrl} /> */}
        </div>

        <Footer
          dark={dark}
          setDark={setDark}
          darkTog={darkTog}
          darktoggle={darktoggle}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
